import {Injectable} from '@angular/core';

@Injectable()
export class CurrencyUtils {

  public static isEmptyOrNaN(value: string) {
    return value === null || value === '' || Number.isNaN(Number(value.split('.').join('').split(',').join('.')));
  }

  public static convertToEuro(value: string, decimal = 2): string {
    // check if empty
    if (value === '') {
      return '' + value;
    }

    if (typeof value === 'string') {
      value = value.replace(/[.]/g, '');
      value = value.split(',').join('.');
    }

    if (Number.isNaN(Number(value))) {
      return '';
    }

    return Number(value).toLocaleString('de-DE', {minimumFractionDigits: decimal, maximumFractionDigits: decimal});
  }

  public static convertNumberCentToEuro(value: number): string {
    if (value === undefined || value === null) {
      return '';
    } else {
      return this.convertCentToEuro(String(value));
    }
  }

  public static convertCentToEuro(value: string): string {

    // check if empty
    if (value === '') {
      return '' + value;
    }

    try {
      // check if number
      if (Number.isNaN(Number(value))) {
        return '';
      }

      const CENT_DIVIDER = 100;
      // convert cent to euro
      value = String(Number(value) / CENT_DIVIDER).replace('.', ',');

    } catch (e) {
      throw new Error(`Can't cast value ${value} to Number`);
    }

    return CurrencyUtils.convertToEuro(value);
  }

  public static convertEuroToCent(value: string) {
    if (typeof value !== 'string' || value === '') {
      return null;
    }

    return Number(CurrencyUtils.convertToEuro(value).split(',').join('').split('.').join('')).valueOf();
  }

}
